import { html, KompisElement, property, unsafeHTML } from '@inter-ikea-kompis/web-component';
import type { IFinancingOption, ITheme } from '@inter-ikea-kompis/types';
import type { RenderResult } from '@inter-ikea-kompis/web-component';

import FinancialServicesCardStyle from './FinancialServicesCardStyle.js';

export default class FinancialServicesCard extends KompisElement {
	// Theme
	@property({ type: Object, required: true })
	public theme!: ITheme;

	// Financing option.
	@property({ type: Object, required: true })
	public financingOption!: IFinancingOption;

	public override render(): RenderResult {
		return html`<style>
				${FinancialServicesCardStyle.getStyle({
					theme: this.theme
				})}
			</style>
			<div class="financial-services-card">${unsafeHTML(this.financingOption.content)}</div>`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'kompis-financial-services-card': FinancialServicesCard;
	}
}
